.kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.25rem;
  border: 1px solid var(--color-border);
  border-radius: 0.25rem;
  background: var(--color-surface-subtle);
  color: var(--color-muted);
  font-family: var(--font-body-family), sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
}
